<dbw-investor-viewer-accordion
  anchorId="investor-viewer-objectifs"
  accordionTitle="Objectifs"
  [itemsCount]="objectives().length">
  @if (objectives().length === 0) {
    <div class="empty-state">Aucun objectif disponible.</div>
  } @else {
    <div class="section-stack">
      @for (objective of objectives(); track objective.objectiveId) {
        <article class="sub-card dbw-card dbw-card--md">
          <header class="entity-header">
            <div>
              <h5>{{ formatText(objective.objectiveTypeCode) }}</h5>
              <p>
                Objectif #{{ objective.objectiveId }} • ArianeId
                {{ formatText(objective.arianeId) }}
              </p>
            </div>
            <oui-tag
              type="status"
              size="big"
              [status]="objective.isShared ? 'pending' : 'completed'"
            >
              {{ objective.isShared ? "Commun" : "Individuel" }}
            </oui-tag>
          </header>

          <div class="detail-grid">
            <article class="detail-item dbw-card dbw-card--lg">
              <span class="detail-item__label">Montant</span>
              <strong>{{ formatCurrency(objective.amount) }}</strong>
            </article>
            <article class="detail-item dbw-card dbw-card--lg">
              <span class="detail-item__label">Horizon</span>
              <strong>{{ formatNumber(objective.horizon) }}</strong>
            </article>
            <article class="detail-item dbw-card dbw-card--lg">
              <span class="detail-item__label">Priorité</span>
              <strong>{{ formatText(objective.priority) }}</strong>
            </article>
          </div>

          @if (objective.notes?.trim()) {
            <div class="note-banner dbw-card dbw-card--md">
              <span class="identity-item__label">Précisions</span>
              <strong>{{ objective.notes }}</strong>
            </div>
          }
        </article>
      }
    </div>
  }
</dbw-investor-viewer-accordion>
